module.exports = __webpack_public_path__ + "img/CERTIFICADO CONSORCIO-NUEVO 2018.302eef89.png";